import React, { Fragment } from 'react';
import 'antd/dist/antd.css';
import { Col, Row, Space, Skeleton } from 'antd';

const ViewSkeleton = () => (
  <Fragment>
    <Row>
      <Col span={12}>
        <Skeleton active title></Skeleton>
        <Skeleton active title></Skeleton>
        <Skeleton active title></Skeleton>
        <Row>
          <Col sm={24} className="d-flex justify-content-end">
            <Space>
              <Skeleton.Button active />
              <Skeleton.Button active />
            </Space>
          </Col>
        </Row>
        <Skeleton avatar active />
        <Skeleton avatar active />
        <Skeleton avatar active />
      </Col>
      <Col span={12}>
        <Skeleton.Image style={{ width: '500px', height: '800px' }} />
      </Col>
    </Row>
  </Fragment>
);

export default ViewSkeleton;